import { render, staticRenderFns } from "./Packery.vue?vue&type=template&id=1b443ca8&scoped=true&"
import script from "./Packery.vue?vue&type=script&lang=js&"
export * from "./Packery.vue?vue&type=script&lang=js&"
import style0 from "./Packery.vue?vue&type=style&index=0&id=1b443ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b443ca8",
  null
  
)

export default component.exports